/*
 * Marbles ハート（いいね）
 *
 * 設置場所は商品詳細ページといいね一覧ページだけ。商品一覧カード・検索結果・
 * 関連商品には出さないため、それらのテンプレートには手を入れていない。
 *
 * 保存先は端末内の localStorage のみ。ログイン、外部サービス、有料アプリ、
 * 計測タグには一切つながない。保存するのは商品ID（主キー）と handle（商品の
 * 取り直し用）だけで、価格・在庫・商品名は保存しない。
 *
 * 他機能から利用するときの入口:
 *   window.MarblesHeartLikes.list() / has(id) / toggle(id, handle) / count()
 *   document.addEventListener('marbles:likes:change', function (e) { e.detail });
 *
 * 将来アカウント同期を足すときは、この change イベントを購読する側を追加する。
 * このファイル自体はネットワークへ書き込みを行わない。
 */
(function (window, document) {
  'use strict';

  var STORAGE_KEY = 'marbles:likes:v1';
  var SCHEMA_VERSION = 1;
  var MAX_ITEMS = 100;
  var CHANGE_EVENT = 'marbles:likes:change';
  var POP_CLASS = 'mb-heart--pop';
  var LIKED_CLASS = 'is-liked';
  var FETCH_BATCH = 6;
  var toastTimer = null;

  /* ======================================================================
     保存
     ====================================================================== */

  var memoryRecord = null; /* localStorage が使えない端末でも操作だけは通す */
  var storageChecked = false;
  var storageUsable = false;

  function getStorage() {
    if (storageChecked) {
      return storageUsable ? window.localStorage : null;
    }
    storageChecked = true;
    try {
      var probeKey = STORAGE_KEY + ':probe';
      window.localStorage.setItem(probeKey, '1');
      window.localStorage.removeItem(probeKey);
      storageUsable = true;
    } catch (error) {
      storageUsable = false;
    }
    return storageUsable ? window.localStorage : null;
  }

  function isArray(value) {
    return Object.prototype.toString.call(value) === '[object Array]';
  }

  function normalizeId(value) {
    if (value === null || value === undefined) {
      return '';
    }
    return String(value).trim();
  }

  function normalizeHandle(value) {
    if (value === null || value === undefined) {
      return '';
    }
    return String(value).trim();
  }

  function emptyRecord() {
    return { v: SCHEMA_VERSION, items: [] };
  }

  /* 壊れた値・別バージョン・重複を落として、常に扱える形にそろえる */
  function sanitize(record) {
    var clean = emptyRecord();
    if (!record || record.v !== SCHEMA_VERSION || !isArray(record.items)) {
      return clean;
    }
    var seen = {};
    for (var i = 0; i < record.items.length; i++) {
      var raw = record.items[i];
      if (!raw || typeof raw !== 'object') {
        continue;
      }
      var id = normalizeId(raw.id);
      if (!id || seen['#' + id]) {
        continue;
      }
      seen['#' + id] = true;
      var at = typeof raw.at === 'number' && isFinite(raw.at) ? raw.at : 0;
      clean.items.push({ id: id, handle: normalizeHandle(raw.handle), at: at });
      if (clean.items.length >= MAX_ITEMS) {
        break;
      }
    }
    return clean;
  }

  function read() {
    var store = getStorage();
    if (!store) {
      return sanitize(memoryRecord);
    }
    var raw;
    try {
      raw = store.getItem(STORAGE_KEY);
    } catch (error) {
      return sanitize(memoryRecord);
    }
    if (!raw) {
      return emptyRecord();
    }
    var parsed;
    try {
      parsed = JSON.parse(raw);
    } catch (error) {
      return emptyRecord();
    }
    return sanitize(parsed);
  }

  function write(record) {
    memoryRecord = record;
    var store = getStorage();
    if (!store) {
      return false;
    }
    try {
      store.setItem(STORAGE_KEY, JSON.stringify(record));
      return true;
    } catch (error) {
      /* 容量超過などでも画面の操作は続けられるようにする */
      return false;
    }
  }

  function indexOfId(items, id) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].id === id) {
        return i;
      }
    }
    return -1;
  }

  /* ======================================================================
     公開API
     ====================================================================== */

  function list() {
    return read().items.slice();
  }

  function ids() {
    var items = read().items;
    var out = [];
    for (var i = 0; i < items.length; i++) {
      out.push(items[i].id);
    }
    return out;
  }

  function count() {
    return read().items.length;
  }

  function has(id) {
    var key = normalizeId(id);
    if (!key) {
      return false;
    }
    return indexOfId(read().items, key) > -1;
  }

  function add(id, handle) {
    var key = normalizeId(id);
    if (!key) {
      return false;
    }
    var record = read();
    var at = indexOfId(record.items, key);
    var entry = { id: key, handle: normalizeHandle(handle), at: Date.now() };
    if (at > -1) {
      /* handle は商品の取り直しに使うので、押されるたびに最新に更新する */
      if (!entry.handle) {
        entry.handle = record.items[at].handle;
      }
      entry.at = record.items[at].at || entry.at;
      record.items.splice(at, 1);
    }
    record.items.unshift(entry);
    if (record.items.length > MAX_ITEMS) {
      record.items.length = MAX_ITEMS;
    }
    write(record);
    return true;
  }

  function remove(id) {
    var key = normalizeId(id);
    if (!key) {
      return false;
    }
    var record = read();
    var at = indexOfId(record.items, key);
    if (at < 0) {
      return false;
    }
    record.items.splice(at, 1);
    write(record);
    return true;
  }

  function clear() {
    write(emptyRecord());
  }

  function toggle(id, handle) {
    if (has(id)) {
      remove(id);
      return false;
    }
    add(id, handle);
    return true;
  }

  /* ======================================================================
     画面の同期
     ====================================================================== */

  function canUseDom() {
    return !!(document && document.addEventListener && document.querySelectorAll);
  }

  function heartButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var found = scope.querySelectorAll('[data-mb-heart]');
    var out = [];
    for (var i = 0; i < found.length; i++) {
      out.push(found[i]);
    }
    return out;
  }

  function applyState(button, liked) {
    if (!button || !button.setAttribute) {
      return;
    }
    button.setAttribute('aria-pressed', liked ? 'true' : 'false');
    var label = liked
      ? button.getAttribute('data-mb-heart-label-on')
      : button.getAttribute('data-mb-heart-label-off');
    if (label) {
      button.setAttribute('aria-label', label);
    }
    if (button.classList) {
      if (liked) {
        button.classList.add(LIKED_CLASS);
      } else {
        button.classList.remove(LIKED_CLASS);
      }
    }
  }

  /* 同じ商品のハートが同じページに何個あっても、まとめて同じ状態にする */
  function syncButtons(root) {
    if (!canUseDom()) {
      return;
    }
    var liked = {};
    var stored = read().items;
    for (var i = 0; i < stored.length; i++) {
      liked['#' + stored[i].id] = true;
    }
    var buttons = heartButtons(root);
    for (var b = 0; b < buttons.length; b++) {
      var id = normalizeId(buttons[b].getAttribute('data-mb-heart-id'));
      applyState(buttons[b], !!liked['#' + id]);
    }
  }

  function pop(button) {
    if (!button || !button.classList) {
      return;
    }
    button.classList.remove(POP_CLASS);
    /* クラスを付け直したときに再生させるため、一度レイアウトを読む */
    if (typeof button.offsetWidth === 'number') {
      void button.offsetWidth;
    }
    button.classList.add(POP_CLASS);
    window.setTimeout(function () {
      button.classList.remove(POP_CLASS);
    }, 400);
  }

  function notify(detail) {
    if (!canUseDom() || typeof window.CustomEvent !== 'function') {
      return;
    }
    document.dispatchEvent(new window.CustomEvent(CHANGE_EVENT, {
      bubbles: true,
      detail: detail
    }));
  }

  function showWishlistToast(button, liked) {
    if (!canUseDom() || !document.createElement || !document.body || !document.body.appendChild) {
      return;
    }
    var messageAttribute = liked
      ? 'data-mb-wishlist-added-message'
      : 'data-mb-wishlist-removed-message';
    var message = button && button.getAttribute
      ? button.getAttribute(messageAttribute)
      : '';
    if (!message) {
      message = liked
        ? 'ウィッシュリストに登録しました。'
        : 'ウィッシュリストを解除しました。';
    }
    var toast = document.querySelector('[data-mb-wishlist-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'mb-wishlist-toast';
      toast.setAttribute('data-mb-wishlist-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.setAttribute('aria-atomic', 'true');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.remove('is-visible');
    if (typeof toast.offsetWidth === 'number') {
      void toast.offsetWidth;
    }
    toast.classList.add('is-visible');
    if (toastTimer && typeof window.clearTimeout === 'function') {
      window.clearTimeout(toastTimer);
    }
    toastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3000);
  }

  function closestHeart(node) {
    var current = node;
    while (current && current !== document) {
      if (current.getAttribute && current.hasAttribute && current.hasAttribute('data-mb-heart')) {
        return current;
      }
      current = current.parentNode;
    }
    return null;
  }

  function onClick(event) {
    var button = closestHeart(event.target);
    if (!button) {
      return;
    }
    /* いいね一覧では商品リンクに重なるので、背後のリンクへ遷移させない */
    event.preventDefault();
    event.stopPropagation();

    var id = normalizeId(button.getAttribute('data-mb-heart-id'));
    if (!id) {
      return;
    }
    var handle = normalizeHandle(button.getAttribute('data-mb-heart-handle'));
    var liked = toggle(id, handle);
    syncButtons();
    if (liked) {
      pop(button);
    }
    showWishlistToast(button, liked);
    notify({ id: id, handle: handle, liked: liked, count: count(), source: 'heart' });
  }

  /* ======================================================================
     いいね一覧
     価格・在庫はここでShopifyから取り直す。保存済みの古い値は使わない。
     ====================================================================== */

  function rootUrl(container) {
    var configured = container && container.getAttribute
      ? container.getAttribute('data-mb-likes-root-url')
      : '';
    var base = configured
      || (window.theme && window.theme.routes && window.theme.routes.root_url)
      || '/';
    if (base.charAt(base.length - 1) !== '/') {
      base += '/';
    }
    return base;
  }

  function sizedImage(url, width) {
    if (!url) {
      return '';
    }
    var src = String(url);
    if (src.indexOf('//') === 0) {
      src = 'https:' + src;
    }
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '¥{{amount_no_decimals}}';
    var vendor = window.pipelineVendor;
    if (vendor && vendor.themeCurrency && typeof vendor.themeCurrency.formatMoney === 'function') {
      try {
        return vendor.themeCurrency.formatMoney(cents, format);
      } catch (error) {
        /* テーマ側の書式に問題があっても一覧は出す */
      }
    }
    return fallbackMoney(cents, format);
  }

  function groupThousands(value, separator) {
    return String(value).replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + separator);
  }

  function fallbackMoney(cents, format) {
    var amount = Number(cents);
    if (!isFinite(amount)) {
      return '';
    }
    return String(format).replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
      switch (name) {
        case 'amount':
          return groupThousands((amount / 100).toFixed(2).split('.')[0], ',') + '.' + (amount / 100).toFixed(2).split('.')[1];
        case 'amount_no_decimals':
          return groupThousands(Math.round(amount / 100), ',');
        case 'amount_with_comma_separator':
          return groupThousands((amount / 100).toFixed(2).split('.')[0], '.') + ',' + (amount / 100).toFixed(2).split('.')[1];
        case 'amount_no_decimals_with_comma_separator':
          return groupThousands(Math.round(amount / 100), '.');
        case 'amount_with_space_separator':
          return groupThousands((amount / 100).toFixed(2).split('.')[0], ' ') + ',' + (amount / 100).toFixed(2).split('.')[1];
        case 'amount_no_decimals_with_space_separator':
          return groupThousands(Math.round(amount / 100), ' ');
        default:
          return match;
      }
    });
  }

  function element(tag, className) {
    var node = document.createElement(tag);
    if (className) {
      node.className = className;
    }
    return node;
  }

  function heartFor(container, item, title) {
    var template = container.querySelector('[data-mb-heart-template]');
    if (!template || !template.content || !template.content.firstElementChild) {
      return null;
    }
    var button = template.content.firstElementChild.cloneNode(true);
    var name = title || '';
    button.setAttribute('data-mb-heart-id', item.id);
    button.setAttribute('data-mb-heart-handle', item.handle || '');
    button.setAttribute('data-mb-heart-label-off', name + 'をWISH LISTに登録する');
    button.setAttribute('data-mb-heart-label-on', name + 'をWISH LISTから解除する');
    return button;
  }

  function placeholderCard() {
    var card = element('div', 'mb-likes__card mb-likes__card--placeholder');
    var frame = element('div', 'mb-likes__frame');
    frame.appendChild(element('span', 'mb-likes__media'));
    card.appendChild(frame);
    var info = element('div', 'mb-likes__info');
    var title = element('p', 'mb-likes__title');
    title.textContent = '　';
    var price = element('p', 'mb-likes__price');
    price.textContent = '　';
    info.appendChild(title);
    info.appendChild(price);
    card.appendChild(info);
    return card;
  }

  function productCard(container, item, product, base) {
    var card = element('div', 'mb-likes__card');
    card.setAttribute('data-mb-likes-card', '');
    card.setAttribute('data-mb-likes-card-id', item.id);

    var title = product ? String(product.title || '') : '';
    var url = product ? base + 'products/' + encodeURIComponent(product.handle || item.handle) : '';

    var frame = element('div', 'mb-likes__frame');
    if (product) {
      /* 画像のない商品では img を作らない。枠は padding-top で保つので高さは変わらない */
      var source = sizedImage(product.featured_image, 540);
      var link = element('a', 'mb-likes__media' + (source ? '' : ' mb-likes__media--empty'));
      link.setAttribute('href', url);
      if (source) {
        var image = element('img');
        image.setAttribute('src', source);
        image.setAttribute('alt', title);
        image.setAttribute('loading', 'lazy');
        link.appendChild(image);
      }
      frame.appendChild(link);
    } else {
      frame.appendChild(element('span', 'mb-likes__media mb-likes__media--empty'));
    }
    var heart = heartFor(container, item, title);
    if (heart) {
      frame.appendChild(heart);
    }
    card.appendChild(frame);

    var info = element('div', 'mb-likes__info');
    var heading = element('p', 'mb-likes__title');
    if (product) {
      var titleLink = element('a');
      titleLink.setAttribute('href', url);
      titleLink.textContent = title;
      heading.appendChild(titleLink);
    } else {
      heading.textContent = '商品情報を取得できませんでした';
    }
    info.appendChild(heading);

    if (product) {
      var price = element('p', 'mb-likes__price');
      var amount = formatMoney(product.price);
      price.textContent = product.price_varies ? amount + '〜' : amount;
      info.appendChild(price);
      if (!product.available) {
        var soldOut = element('p', 'mb-likes__note');
        soldOut.textContent = 'SOLD OUT';
        info.appendChild(soldOut);
      }
    } else {
      var note = element('p', 'mb-likes__note');
      note.textContent = '販売を終了した可能性があります';
      info.appendChild(note);
    }
    card.appendChild(info);
    return card;
  }

  /* handle が別商品に付け替えられている場合があるので、必ずIDの一致を確かめる */
  function fetchProduct(base, item) {
    if (!item.handle || typeof window.fetch !== 'function') {
      return Promise.resolve(null);
    }
    var url = base + 'products/' + encodeURIComponent(item.handle) + '.js';
    return window.fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response || !response.ok) {
          return null;
        }
        return response.json();
      })
      .then(function (product) {
        if (!product || normalizeId(product.id) !== item.id) {
          return null;
        }
        return product;
      })
      .catch(function () {
        return null;
      });
  }

  function fetchInBatches(base, items, onResolved) {
    var cursor = 0;
    function next() {
      if (cursor >= items.length) {
        return Promise.resolve();
      }
      var slice = items.slice(cursor, cursor + FETCH_BATCH);
      cursor += FETCH_BATCH;
      return Promise.all(slice.map(function (item) {
        return fetchProduct(base, item).then(function (product) {
          onResolved(item, product);
        });
      })).then(next);
    }
    return next();
  }

  function renderLikesPage(container) {
    if (!container) {
      return;
    }
    var grid = container.querySelector('[data-mb-likes-grid]');
    var empty = container.querySelector('[data-mb-likes-empty]');
    var counter = container.querySelector('[data-mb-likes-count]');
    if (!grid || !empty) {
      return;
    }
    /* 取得手段のない古い環境では、壊れた見た目を出さずに空状態のままにする */
    if (typeof window.fetch !== 'function' || typeof window.Promise !== 'function') {
      return;
    }

    var items = list();
    if (counter) {
      counter.textContent = items.length ? items.length + ' 件' : '';
    }
    grid.innerHTML = '';

    if (!items.length) {
      grid.hidden = true;
      empty.hidden = false;
      return;
    }
    empty.hidden = true;
    grid.hidden = false;

    /* 取得を待つあいだも高さを確保しておき、表示のがたつきを防ぐ */
    var slots = {};
    for (var i = 0; i < items.length; i++) {
      var slot = placeholderCard();
      slots['#' + items[i].id] = slot;
      grid.appendChild(slot);
    }

    var base = rootUrl(container);
    fetchInBatches(base, items, function (item, product) {
      var slot = slots['#' + item.id];
      if (!slot || !slot.parentNode) {
        return;
      }
      slot.parentNode.replaceChild(productCard(container, item, product, base), slot);
      syncButtons(container);
    });
  }

  function likesContainers() {
    if (!canUseDom()) {
      return [];
    }
    var found = document.querySelectorAll('[data-mb-likes-root]');
    var out = [];
    for (var i = 0; i < found.length; i++) {
      out.push(found[i]);
    }
    return out;
  }

  function renderAllLikesPages() {
    var containers = likesContainers();
    for (var i = 0; i < containers.length; i++) {
      renderLikesPage(containers[i]);
    }
  }

  /* 一覧ページで解除されたら、その場でカードも消す */
  function onChange(event) {
    var detail = event && event.detail;
    if (!detail || detail.liked) {
      return;
    }
    var containers = likesContainers();
    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];
      var card = container.querySelector('[data-mb-likes-card-id="' + detail.id + '"]');
      if (!card) {
        continue;
      }
      renderLikesPage(container);
    }
  }

  /* ======================================================================
     起動
     ====================================================================== */

  var cartObserver = null;

  function setBadgeValue(selector, value) {
    var badges = document.querySelectorAll(selector);
    var display = value > 99 ? '99+' : String(value);
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = display;
      badges[i].hidden = value < 1;
    }
  }

  function syncLikeBadges() {
    if (!canUseDom()) {
      return;
    }
    setBadgeValue('[data-mb-likes-badge]', count());
  }

  function cartCountFromHeader() {
    var source = document.querySelector('[data-header-cart-count]');
    if (!source) {
      return 0;
    }
    var raw = source.getAttribute('data-header-cart-count') || source.textContent || '0';
    var match = String(raw).match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  }

  function syncCartBadges() {
    if (!canUseDom()) {
      return;
    }
    setBadgeValue('[data-mb-cart-badge]', cartCountFromHeader());
  }

  function mutationContainsCartCount(mutation) {
    var node = mutation && mutation.target;
    if (node && node.nodeType === 3) {
      node = node.parentNode;
    }
    if (!node || !node.getAttribute) {
      return false;
    }
    if (node.hasAttribute('data-header-cart-count')) {
      return true;
    }
    return !!(mutation.type === 'childList' && node.querySelector && node.querySelector('[data-header-cart-count]'));
  }

  function observeCartCount() {
    if (!canUseDom() || typeof window.MutationObserver !== 'function') {
      return;
    }
    var header = document.querySelector('[data-header-wrapper]');
    if (!header) {
      return;
    }
    if (cartObserver) {
      cartObserver.disconnect();
    }
    cartObserver = new window.MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutationContainsCartCount(mutations[i])) {
          syncCartBadges();
          return;
        }
      }
    });
    cartObserver.observe(header, {
      attributes: true,
      attributeFilter: ['data-header-cart-count'],
      characterData: true,
      childList: true,
      subtree: true
    });
  }

  function refresh() {
    syncButtons();
    syncLikeBadges();
    syncCartBadges();
    observeCartCount();
    renderAllLikesPages();
  }

  function init() {
    if (!canUseDom()) {
      return;
    }
    document.addEventListener('click', onClick);
    document.addEventListener(CHANGE_EVENT, onChange);
    document.addEventListener(CHANGE_EVENT, syncLikeBadges);
    document.addEventListener('cart:updated', syncCartBadges);
    document.addEventListener('cart:change', syncCartBadges);
    document.addEventListener('theme:cart:change', syncCartBadges);
    /* 別タブでの追加・解除を反映する */
    window.addEventListener('storage', function (event) {
      if (event && event.key && event.key !== STORAGE_KEY) {
        return;
      }
      refresh();
    });
    /* テーマエディタでセクションが差し替わったとき */
    document.addEventListener('shopify:section:load', function () {
      refresh();
    });
    refresh();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refresh);
    }
  }

  window.MarblesHeartLikes = {
    STORAGE_KEY: STORAGE_KEY,
    VERSION: SCHEMA_VERSION,
    CHANGE_EVENT: CHANGE_EVENT,
    MAX_ITEMS: MAX_ITEMS,
    list: list,
    ids: ids,
    count: count,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    clear: clear,
    refresh: refresh,
    formatMoney: formatMoney
  };

  init();
}(window, document));
